
import { Base } from '../../components/base-component';
import './calculator-personalloans-v2-item.component.scss';

export class CalculatorPersonalloansV2Item extends Base {

	constructor(element: Element) {
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components-wpbbsa/calculator-personalloans-v2-item/calculator-personalloans-v2-item.component.ts